<div class="container-fluid">
  <div class="row">
    <table class="table table-hover table-striped">
      <thead>
        <tr>
          <th>CO\PO - PSO</th>
          <th>PO1</th>
          <th>PO2</th>
          <th>PO3</th>
          <th>PO4</th>
          <th>PO5</th>
          <th>PO6</th>
          <th>PO7</th>
          <th>PO8</th>
          <th>PO9</th>
          <th>PO10</th>
          <th>PO11</th>
          <th>PO12</th>
          <th>PSO1</th>
          <th>PSO2</th>
          <th>PSO3</th>
        </tr>
      </thead>
      <tbody>
        <tr class="form-group" *ngFor="let factor of Classroom['po_attainment']" contenteditable="true">
          <th>{{factor.subject_code}} - {{factor.subject_name}}</th>
          <th>{{factor.po1_attainment}}</th>
          <th>{{factor.po2_attainment}}</th>
          <th>{{factor.po3_attainment}}</th>
          <th>{{factor.po4_attainment}}</th>
          <th>{{factor.po5_attainment}}</th>
          <th>{{factor.po6_attainment}}</th>
          <th>{{factor.po7_attainment}}</th>
          <th>{{factor.po8_attainment}}</th>
          <th>{{factor.po9_attainment}}</th>
          <th>{{factor.po10_attainment}}</th>
          <th>{{factor.po11_attainment}}</th>
          <th>{{factor.po12_attainment}}</th>

          <th>{{factor.pso1_attainment}}</th>
          <th>{{factor.pso2_attainment}}</th>
          <th>{{factor.pso3_attainment}}</th>
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <th>Direct attainment :</th>
          <th>{{Classroom.direct_po1}}</th>
          <th>{{Classroom.direct_po2}}</th>
          <th>{{Classroom.direct_po3}}</th>
          <th>{{Classroom.direct_po4}}</th>
          <th>{{Classroom.direct_po5}}</th>
          <th>{{Classroom.direct_po6}}</th>
          <th>{{Classroom.direct_po7}}</th>
          <th>{{Classroom.direct_po8}}</th>
          <th>{{Classroom.direct_po9}}</th>
          <th>{{Classroom.direct_po10}}</th>
          <th>{{Classroom.direct_po11}}</th>
          <th>{{Classroom.direct_po12}}</th>

          <th>{{Classroom.direct_pso1}}</th>
          <th>{{Classroom.direct_pso2}}</th>
          <th>{{Classroom.direct_pso3}}</th>
        </tr>
        <tr>
          <th>Indirect attainment :</th>
          <!-- <input (input)="update_threshold(field)" [(ngModel)]=field.attainment_field_threshold> -->
          <th>{{Classroom.indirect_po1}}</th>
          <th>{{Classroom.indirect_po2}}</th>
          <th>{{Classroom.indirect_po3}}</th>
          <th>{{Classroom.indirect_po4}}</th>
          <th>{{Classroom.indirect_po5}}</th>
          <th>{{Classroom.indirect_po6}}</th>
          <th>{{Classroom.indirect_po7}}</th>
          <th>{{Classroom.indirect_po8}}</th>
          <th>{{Classroom.indirect_po9}}</th>
          <th>{{Classroom.indirect_po10}}</th>
          <th>{{Classroom.indirect_po11}}</th>
          <th>{{Classroom.indirect_po12}}</th>

          <th>{{Classroom.indirect_pso1}}</th>
          <th>{{Classroom.indirect_pso2}}</th>
          <th>{{Classroom.indirect_pso3}}</th>
        </tr>
        <tr>
          <th>Direct 80% :</th>
          <th>{{Classroom.direct_80_po1}}</th>
          <th>{{Classroom.direct_80_po2}}</th>
          <th>{{Classroom.direct_80_po3}}</th>
          <th>{{Classroom.direct_80_po4}}</th>
          <th>{{Classroom.direct_80_po5}}</th>
          <th>{{Classroom.direct_80_po6}}</th>
          <th>{{Classroom.direct_80_po7}}</th>
          <th>{{Classroom.direct_80_po8}}</th>
          <th>{{Classroom.direct_80_po9}}</th>
          <th>{{Classroom.direct_80_po10}}</th>
          <th>{{Classroom.direct_80_po11}}</th>
          <th>{{Classroom.direct_80_po12}}</th>

          <th>{{Classroom.direct_80_pso1}}</th>
          <th>{{Classroom.direct_80_pso2}}</th>
          <th>{{Classroom.direct_80_pso3}}</th>

        </tr>
        <tr>
          <th>Indirect 20% :</th>
          <th>{{Classroom.indirect_20_po1}}</th>
          <th>{{Classroom.indirect_20_po2}}</th>
          <th>{{Classroom.indirect_20_po3}}</th>
          <th>{{Classroom.indirect_20_po4}}</th>
          <th>{{Classroom.indirect_20_po5}}</th>
          <th>{{Classroom.indirect_20_po6}}</th>
          <th>{{Classroom.indirect_20_po7}}</th>
          <th>{{Classroom.indirect_20_po8}}</th>
          <th>{{Classroom.indirect_20_po9}}</th>
          <th>{{Classroom.indirect_20_po10}}</th>
          <th>{{Classroom.indirect_20_po11}}</th>
          <th>{{Classroom.indirect_20_po12}}</th>

          <th>{{Classroom.indirect_20_pso1}}</th>
          <th>{{Classroom.indirect_20_pso2}}</th>
          <th>{{Classroom.indirect_20_pso3}}</th>

        </tr>
        <tr>
          <th>PO Attainment:</th>
          <th>{{Classroom.attainment_po1}}</th>
          <th>{{Classroom.attainment_po2}}</th>
          <th>{{Classroom.attainment_po3}}</th>
          <th>{{Classroom.attainment_po4}}</th>
          <th>{{Classroom.attainment_po5}}</th>
          <th>{{Classroom.attainment_po6}}</th>
          <th>{{Classroom.attainment_po7}}</th>
          <th>{{Classroom.attainment_po8}}</th>
          <th>{{Classroom.attainment_po9}}</th>
          <th>{{Classroom.attainment_po10}}</th>
          <th>{{Classroom.attainment_po11}}</th>
          <th>{{Classroom.attainment_po12}}</th>

          <th>{{Classroom.attainment_pso1}}</th>
          <th>{{Classroom.attainment_pso2}}</th>
          <th>{{Classroom.attainment_pso3}}</th>
        </tr>
      </tfoot>

    </table>
  </div>
</div>


<div>
  <div>
    <div style="display: block">
      <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
        [legend]="barChartLegend" [chartType]="barChartType">
      </canvas>
    </div>
  </div>
</div>
